import React from "react";

interface ChevronLeftProps {
  style?: React.CSSProperties;
  className?: string;
}

function ChevronLeft({ style, className }: ChevronLeftProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      width="100%"
      height="100%"
      fill="currentColor"
      style={style}
      className={className}
    >
      <path
        d="M5.17 6.092l3.33-3.33L7.737 2 3.645 6.092l4.092 4.093.763-.763-3.33-3.33z"
      ></path>
    </svg>
  );
}

export default ChevronLeft;
